import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
} from 'react'

interface TitleConfig {
  en: string
  zh_cn: string
  zh_hk: string
}

interface LayoutConfig {
  showSidebar: boolean
  showHeader: boolean
  showFooter: boolean
  title?: string | TitleConfig
}

interface LayoutContextType {
  config: LayoutConfig
  setLayoutConfig: (config: Partial<LayoutConfig>) => void
}

const defaultConfig: LayoutConfig = {
  showSidebar: true,
  showHeader: true,
  showFooter: true,
  title: '',
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined)

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<LayoutConfig>(defaultConfig)

  const setLayoutConfig = useCallback((newConfig: Partial<LayoutConfig>) => {
    setConfig(prev => ({ ...prev, ...newConfig }))
  }, [])

  return (
    <LayoutContext.Provider value={{ config, setLayoutConfig }}>
      {children}
    </LayoutContext.Provider>
  )
}

export function useLayout() {
  const context = useContext(LayoutContext)
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider')
  }
  return context
}
